module.exports = __webpack_public_path__ + "static/img/certificado.234cb3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/certificado.png
// module id = FuEi
// module chunks = 0